import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createPollEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
// import { IReduxState } from '../../app/types';
import { getParticipantDisplayName, getParticipantById, getLocalParticipant } from '../../base/participants/functions';
// import { getLocalParticipant, getParticipantById } from '../../base/participants';
import { useBoundSelector } from '../../base/util/hooks';
import { registerVote, setVoteChanging } from '../actions';
import { COMMAND_ANSWER_POLL } from '../constants';
/**
 * Higher Order Component taking in a concrete PollAnswer component and
 * augmenting it with state/behavior common to both web and native implementations.
 *
 * @param {React.AbstractComponent} Component - The concrete component.
 * @returns {React.AbstractComponent}
 */
const AbstractPollAnswer = (Component) => (props) => {
    const { pollId } = props;
    const conference = useSelector((state) => state['features/base/conference'].conference);
    const poll = useSelector((state) => state['features/polls'].polls[pollId]);
    const { id: localId } = useSelector(getLocalParticipant);
    const [checkBoxStates, setCheckBoxState] = useState(() => {
        if (poll.lastVote !== null) {
            return [...poll.lastVote];
        }
        return new Array(poll.answers.length).fill(false);
    });
    const participantName = useBoundSelector(getParticipantDisplayName, poll.senderId);
    const participant = useBoundSelector(getParticipantById, poll.senderId);
    const setCheckbox = useCallback((index, state) => {
        const newCheckBoxStates = [...checkBoxStates];
        if (poll.pollType === 'single-select') {
            // For single-select polls, clear all other selections
            newCheckBoxStates.fill(false);
            newCheckBoxStates[index] = state;
        }
        else {
            // For multi-select polls, toggle the specific option
            newCheckBoxStates[index] = state;
        }
        setCheckBoxState(newCheckBoxStates);
        sendAnalytics(createPollEvent('vote.checked'));
    }, [checkBoxStates, poll.pollType]);
    const dispatch = useDispatch();
    const localParticipant = useBoundSelector(getParticipantById, localId);
    const localName = localParticipant.name ? localParticipant.name : 'Fellow Jitster';
    const submitAnswer = useCallback(() => {
        conference.sendMessage({
            type: COMMAND_ANSWER_POLL,
            pollId,
            voterId: localId,
            voterName: localName,
            answers: checkBoxStates
        });
        sendAnalytics(createPollEvent('vote.sent'));
        dispatch(registerVote(pollId, checkBoxStates));
        return false;
    }, [pollId, checkBoxStates, conference]);
    const skipAnswer = useCallback(() => {
        dispatch(registerVote(pollId, null));
        sendAnalytics(createPollEvent('vote.skipped'));
    }, [pollId]);
    const skipChangeVote = useCallback(() => {
        dispatch(setVoteChanging(pollId, false));
    }, [dispatch, pollId]);
    const { t } = useTranslation();
    return (React.createElement(Component, { checkBoxStates: checkBoxStates, creatorName: participantName, poll: poll, setCheckbox: setCheckbox, skipAnswer: skipAnswer, skipChangeVote: skipChangeVote, submitAnswer: submitAnswer, t: t }));
};
export default AbstractPollAnswer;
